/**
 * Browser fingerprinting
 *
 * Takes a fingerprints of the browser and sends it to the server
 *
 * @see https://github.com/Valve/fingerprintjs2
 */
import Fingerprint2 from 'fingerprintjs2'
import io from 'service/io'
import Router from 'service/router'
import Logger from 'service/logger'
import cookieStorage from 'service/cookie_storage'
import parseUserAgent from 'ua-parser-js'

const COOKIE_NAME = 'INFP'

const ValueFilter = {
    userAgent(value) {
        const result = parseUserAgent(value)
        return `${result.os.name} ${result.browser.name}`
    },
}

const OPTIONS = {
    swfPath: false,
    excludeJsFonts: false,
    preprocessor(key, value) {
        return (ValueFilter[key] || ((v) => v))(value)
    },
}

function onFingerprintTaken(fingerprint) {
    io.request(Router.path('fraud_protection_api_browser_fingerprint_put'), {
        method: 'POST',
        data: { fingerprint, _method: 'PUT' },
        dataType: 'json',
    })
        .then(onFingerprintStored)
        .fail(onStoringFingerprintFailed)
}

function onFingerprintStored() {
    Logger.debug('Fingerprint successfully stored')
}

function onStoringFingerprintFailed({ status, statusText, readyState }) {
    Logger.error(`Error storing fingerprint: ${status} ${statusText} (${readyState})`)
}

export default function fingerprint() {
    Fingerprint2.getV18(OPTIONS, onFingerprintTaken)
}

export function lazyFingerprint() {
    const encryptedFingerprint = cookieStorage.get(COOKIE_NAME) || ''
    if (encryptedFingerprint.length > 128 && /==$/.test(encryptedFingerprint)) {
        Logger.debug('Fingerprint cookie already exists. Not taking fingerprint')
    } else {
        fingerprint()
        Logger.debug('Fingerprint cookie does not exists. Taking fingerprint')
    }
}
